// Handle visibility of user interactions on Beteiligungsportal - Register, Login, Logout, Profile
// see doc here:
// https://gitlab.rsm-support.de/bawue/frontend/blob/master/src/docs/1-documentation.md#bp-user-actions
export default class LoginHandler {
  static navigationFunctions($body) {
    const $loginButton = $body.querySelector('#js-bp-login');
    const $logoutButton = $body.querySelector('#js-bp-logout');
    const $profileButton = $body.querySelector('#js-bp-profile');
    const $navigationFunctions = $body.querySelector('.header__navigation-functions');

    if (!$loginButton && !$logoutButton && !$profileButton) {
      return;
    }
    if ($navigationFunctions) {
      $navigationFunctions.classList.add('header__navigation-functions--initialized');
    }
    LoginHandler.handleButtonVisibility($loginButton, $logoutButton, $profileButton);
  }

  static handleButtonVisibility($loginButton, $logoutButton, $profileButton) {
    const loginState = LoginHandler.getLoginState();
    const hideClass = 'u-hidden-visually';
    if (!loginState) {
      if ($loginButton) {
        $loginButton.classList.remove(hideClass);
        $loginButton.setAttribute('style', 'margin-right: 0;');
      }
      if ($logoutButton) { $logoutButton.classList.add(hideClass); }
      if ($profileButton) { $profileButton.classList.add(hideClass); }
    } else {
      if ($loginButton) {
        $loginButton.classList.add(hideClass);
        $loginButton.removeAttribute('style');
      }
      if ($logoutButton) { $logoutButton.classList.remove(hideClass); }
      if ($profileButton) { $profileButton.classList.remove(hideClass); }
    }
  }

  static getLoginState() {
    const cookieValue = document.cookie.replace(/(?:(?:^|.*;\s*)loginState\s*=\s*([^;]*).*$)|^.*$/, '$1');
    return cookieValue === 'true';
  }

  static setLoginState(value) {
    document.cookie = `loginState=${value}`;

    const $bp = document.querySelector('.v-bp');
    if ($bp) {
      LoginHandler.navigationFunctions($bp);
    }
  }
}

document.querySelectorAll('.v-bp').forEach(($body) => {
  LoginHandler.navigationFunctions($body);
});

window.LoginHandler = LoginHandler;
